import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartSuggestionCardsBlockConfig } from '@front-platform/content-builder';
import { cartSuggestionCardsBlockResolveConfig } from '@front-platform/content-builder';
import { Component, effect, inject, Inject, input, computed } from '@angular/core';
import { Router } from '@angular/router';
import { suggestionProductOrigin } from '@core/models/suggestion-channel.util';

import { DoodProductModel } from '@core/models/product.model';
import { PRODUCT_STORE_COMPONENT_ACTIONS } from '@store/product';
import { Store } from '@ngrx/store';
import { SettingsStoreSelector } from '@common/selectors/settings.selector';

import {
  CART_SUGGESTION_CARDS_BLOCK_DATA_SOURCE,
  CART_SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET,
  CartSuggestionCardsBlockDataSource,
} from './cart-suggestion-cards-block-view-model';
import { provideCartSuggestionCardsBlockDataSource } from './cart-suggestion-cards-block-data-source.providers';
export interface CartSuggestionCardsBlockRuntimeConfig {}

export type CartSuggestionCardsBlockConfigInput = Partial<
  Omit<CartSuggestionCardsBlockConfig, keyof CartSuggestionCardsBlockRuntimeConfig> &
    CartSuggestionCardsBlockRuntimeConfig
>;
export type CartSuggestionCardsBlockResolvedConfig = Omit<
  CartSuggestionCardsBlockConfig,
  keyof CartSuggestionCardsBlockRuntimeConfig
> &
  Partial<CartSuggestionCardsBlockRuntimeConfig>;
export interface CartSuggestionCardsBlockContract extends ConfigComponentContract<
  CartSuggestionCardsBlockConfigInput,
  CartSuggestionCardsBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-suggestion-cards-block',
  templateUrl: './cart-suggestion-cards-block.component.html',
  standalone: false,
  providers: [...provideCartSuggestionCardsBlockDataSource()],
})
export class CartSuggestionCardsBlockComponent implements CartSuggestionCardsBlockContract {
  readonly config = input<CartSuggestionCardsBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartSuggestionCardsBlockConfig,
    CartSuggestionCardsBlockRuntimeConfig
  >(cartSuggestionCardsBlockResolveConfig, () => ({ config: this.config() }));
  private readonly settingsSelector = inject(SettingsStoreSelector);
  private readonly store = inject(Store);
  private readonly suggestionsSetRef = inject(CART_SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET);

  readonly heading = computed(() => this.resolvedConfig()['heading'] as unknown as string);
  readonly leading = computed(() => this.resolvedConfig()['leading'] as unknown as string);
  readonly suggestionsSet = computed(
    () => this.resolvedConfig()['suggestions_set'] as unknown as string,
  );

  private readonly router = inject(Router);
  protected readonly isMobile = this.settingsSelector.deviceIsMobileScreen;
  protected readonly suggestionsVm$;

  protected currentIndex = 0;
  protected readonly nbDisplayCards = 5;

  constructor(
    @Inject(CART_SUGGESTION_CARDS_BLOCK_DATA_SOURCE)
    blockDataSource: CartSuggestionCardsBlockDataSource,
  ) {
    this.suggestionsVm$ = blockDataSource.vm$;

    effect(() => {
      this.suggestionsSetRef.set(this.suggestionsSet());
    });
  }

  productClick(product: DoodProductModel): void {
    this.store.dispatch(
      PRODUCT_STORE_COMPONENT_ACTIONS.selectProduct({
        productId: product.id,
        productShopId: product.shop_id,
        productOrigin: suggestionProductOrigin(
          this.router.url,
          `suggestion_set_${this.suggestionsSet()}`,
        ),
      }),
    );
  }

  forceType(data: unknown): DoodProductModel {
    return data as DoodProductModel;
  }

  protected prev(): void {
    this.currentIndex = this.currentIndex === 0 ? this.currentIndex : this.currentIndex - 1;
  }

  protected next(): void {
    this.currentIndex = this.currentIndex + 1;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartSuggestionCardsBlockComponent, {
  'keyAliases': {},
});
